import { render } from 'preact';
import { App } from './app/App';
import './styles/app.css';

const root = document.getElementById('app');
if (!root) {
  // The shell HTML always contains #app; if it is missing the build is broken and
  // failing loudly beats rendering nothing.
  throw new Error('missing #app mount point');
}
render(<App />, root);

// Service worker: production builds only (dev server has no sw.js). On sw-updated,
// reload so the page runs the new build — deferred while a sheet/overlay is open so a
// half-written note is never lost; queued IndexedDB work survives reloads by design.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  void navigator.serviceWorker.register('/sw.js');
  navigator.serviceWorker.addEventListener('message', (e: MessageEvent) => {
    if ((e.data as { type?: string })?.type !== 'sw-updated') return;
    const attempt = () => {
      if (document.querySelector('.overlay')) setTimeout(attempt, 3000);
      else location.reload();
    };
    attempt();
  });
}
